/**
 * 趣味关系
 * */
import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import Scrollbar from 'react-scrollbars-custom';
import { Modal, message } from 'antd';
import * as Map from 'immutable';
import HTTP from '../../script/service';
import { connect } from 'react-redux';
import { _change_affinity_modal } from '../../../src/store/Action';
import { DDLoading } from '../globalPageStatus';
import InterestAffinityCard from './components/InterestAffinityCard';
import iconAffinityListEmptyPNG from './img/affinity-list-empty.png';
import './common.scss';

class InterestAffinityDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      loading: false,
      detailVisible: false,
      detail: {},
      list: [],
      searchUid: null,
      otherUid: null,
    };
  }
  // 是否更新数据
  componentDidUpdate(prevProps, prevState, snapshot) {
    const props1 = Map.fromJS(prevProps.base.interestAffinityDetailModal);
    const props2 = Map.fromJS(this.props.base.interestAffinityDetailModal);

    if (!this.props.base.interestAffinityDetailModal) {
    } else if (
      this.props.base.interestAffinityDetailModal &&
      !Map.is(props1, props2)
    ) {
      const { searchUid, otherUid } =
        this.props.base.interestAffinityDetailData;
      this.setState(
        {
          searchUid,
          otherUid,
        },
        () => {
          this.getInterestAffinityDetail();
        }
      );
    }
  }

  hideModal = () => {
    this.setState({
      visible: false,
    });
    _change_affinity_modal({
      interestAffinityDetailModal: false,
      interestAffinityDetailData: null,
    });
  };
  onChangeTab = (tab) => {
    this.setState(
      {
        tab,
      },
      () => {
        this.getAffinityList();
      }
    );
  };

  //获取趣味关系列表
  getInterestAffinityDetail = () => {
    const { searchUid, otherUid } = this.state;
    let params = {
      searchUid,
      otherUid,
    };
    HTTP._get_interest_affinity_detail(params).then((res) => {
      if (res.code == 200) {
        this.setState({ list: res.data || [], visible: true });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { loading, list, visible } = this.state;
    return (
      <div className="affinity-modal">
        <Modal
          open={visible}
          wrapClassName="daidai-modal-style has-top-border"
          zIndex={1002}
          centered={true}
          title={`关系列表`}
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="400px"
          onCancel={this.hideModal}
        >
          <DDLoading status={loading} className="set-plan-spin">
            <div className="affinity-modal-box">
              <Scrollbar
                ref={(el) => (this.scrollElement = el)}
                className="my-scroll-bar"
                style={{ height: '650px' }}
              >
                {list.length > 0 ? (
                  <div className="interest-affinity-card">
                    {list.map((item) => (
                      <InterestAffinityCard
                        key={item.propConfigId}
                        data={item}
                        isOpenDetail={true}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="affinity-empty">
                    <img src={iconAffinityListEmptyPNG} alt="空" />
                    <p>暂无趣味关系好友</p>
                  </div>
                )}
              </Scrollbar>
            </div>
          </DDLoading>
        </Modal>
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(InterestAffinityDetail, { withRef: true })
);
